import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ImageCropperComponent } from './imageCropperComponent';


export class ImageCropperModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [ImageCropperComponent],
    exports: [ImageCropperComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
